import { render, staticRenderFns } from "./edit-audio.vue?vue&type=template&id=4fa6f7cc&scoped=true&"
import script from "./edit-audio.vue?vue&type=script&lang=js&"
export * from "./edit-audio.vue?vue&type=script&lang=js&"
import style0 from "./edit-audio.vue?vue&type=style&index=0&id=4fa6f7cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa6f7cc",
  null
  
)

export default component.exports